/**
 * @generated SignedSource<<29d664e11ec159dbee26ddf80ede40e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignedActorCompactBadge_actor$data = {
  readonly __typename: "ConnectActor";
  readonly " $fragmentType": "SignedActorCompactBadge_actor";
} | {
  readonly __typename: "GroupActor";
  readonly employee: {
    readonly __typename: "Employee";
  } | null;
  readonly user: {
    readonly __typename: "User";
  } | null;
  readonly " $fragmentType": "SignedActorCompactBadge_actor";
} | {
  readonly __typename: "ScreenActor";
  readonly " $fragmentType": "SignedActorCompactBadge_actor";
} | {
  readonly __typename: "UserActor";
  readonly storeUser: {
    readonly user: {
      readonly orgDescription: {
        readonly orgIconUri: string | null;
      } | null;
    };
  } | null;
  readonly " $fragmentType": "SignedActorCompactBadge_actor";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "SignedActorCompactBadge_actor";
};
export type SignedActorCompactBadge_actor$key = {
  readonly " $data"?: SignedActorCompactBadge_actor$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignedActorCompactBadge_actor">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignedActorCompactBadge_actor",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoreUser",
          "kind": "LinkedField",
          "name": "storeUser",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "OrgDescription",
                  "kind": "LinkedField",
                  "name": "orgDescription",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "orgIconUri",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "type": "UserActor",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "employee",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "type": "GroupActor",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "ScreenActor",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v1/*: any*/),
      "type": "ConnectActor",
      "abstractKey": null
    }
  ],
  "type": "Actor",
  "abstractKey": "__isActor"
};
})();

(node as any).hash = "6b9065bf60d0bf769e36c63da271556a";

export default node;
